export enum ExternalTransferFieldNames {
  AMOUNT = 'amount',
  FROM = 'from',
  MEMO = 'memo',
  RECURRING_END_DATE = 'recurringEndDate',
  RECURRING_NUMBER = 'recurringNumber',
  RECURRING_START_DATE = 'recurringStartDate',
  RECURRING_START_DATE_1 = 'recurringStartDate1',
  RECURRING_START_DATE_2 = 'recurringStartDate2',
  RECURRING_TYPE = 'recurringType',
  SCHEDULED_DATE = 'scheduledDate',
  TO = 'to',
  TRANSFER_TYPE = 'transferType',
  DELIVERY_METHOD = 'deliveryMethod',
}
